"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "component"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      "& a": {
        color: theme.palette.primary.main
      }
    }
  };
});

var RichTypography = /*#__PURE__*/_react["default"].forwardRef(function RichTypography(_ref, ref) {
  var children = _ref.children,
      component = _ref.component,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles(props);

  if (!children) {
    return null;
  }

  if (typeof children === "string") {
    return /*#__PURE__*/_react["default"].createElement(_core.Typography // We default to `div` to allow other block elements like <p> to be used inside
    // `children`
    , _extends({
      component: component || "div",
      dangerouslySetInnerHTML: {
        __html: children
      }
    }, props, {
      ref: ref,
      classes: classes
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Typography, _extends({
    component: component
  }, props, {
    ref: ref
  }), children);
});

RichTypography.propTypes = {
  children: _propTypes.PropTypes.node,
  component: _propTypes.PropTypes.elementType
};
RichTypography.defaultProps = {
  children: null,
  component: undefined
};
var _default = RichTypography;
exports["default"] = _default;